<template>
  <div class="sku-edit-page">
    <div class="sku-edit-page__header">
      <Title title="新增 SKU"></Title>
      <div class="sku-edit-page__actions">
        <el-button icon="el-icon-arrow-left" @click="back">返回</el-button>
        <el-button type="primary" icon="el-icon-check" :loading="saving" @click="save">保存</el-button>
      </div>
    </div>

    <SkuForm ref="skuForm" :value="form" :plans="plan_list"></SkuForm>
  </div>
</template>

<script>
import Title from './components/Title'
import SkuForm from './components/SkuForm'
import apis from '@/api/index'

export default {
  name: 'AddSku',
  components: {
    Title,
    SkuForm
  },
  data() {
    return {
      saving: false,
      plan_list: [],
      form: {
        sku_key: '',
        sku_name: '',
        plan_id: '',
        plan_mode: 'dynamic',
        sku_type: 'normal',
        platform: 'win32',
        time_limit: 365,
        allow_device_num: 1,
        price: 0,
        one_device_price: 0,
        enabled: 1,
        sort: 0,
        comment: ''
      }
    }
  },
  methods: {
    getPlans() {
      apis.license.readPlans({ page_num: 1, page_size: 200, enabled: 1 }).then(res => {
        const data = res.data.data || {}
        this.plan_list = data.list || []
      })
    },
    save() {
      this.$refs.skuForm.validate(valid => {
        if (!valid) return
        this.saving = true
        apis.activation_code.saveSku(this.$refs.skuForm.getForm()).then(res => {
          this.$message({ message: res.data.msg, type: res.data.code ? 'success' : 'error' })
          if (res.data.code) {
            this.$router.push({ name: 'codetypeList' })
          }
        }).finally(() => {
          this.saving = false
        })
      })
    },
    back() {
      this.$router.push({ name: 'codetypeList' })
    }
  },
  mounted() {
    this.getPlans()
  }
}
</script>

<style lang="scss" scoped>
.sku-edit-page {
  padding: 15px;
}

.sku-edit-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
}

.sku-edit-page__actions {
  display: flex;
  gap: 10px;
}
</style>
